import { getCurrentInstance } from '@vue/composition-api';
import { Route } from 'vue-router';

export function useRoute(): Route {
  const instance = getCurrentInstance();

  if (!instance) {
    throw new Error(`useRouteはsetupメソッド内でしか使用できません。`);
  }

  return instance.proxy.$route;
}
